/* eslint-disable */
import React, { useEffect, useMemo, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import moment from 'moment';
import { Manager, Reference, Popper } from 'react-popper';
import Chip from '@material-ui/core/Chip';
import currencyToSymbolMap from 'currency-symbol-map';
import { useSelector } from 'react-redux';
import iconTrash from '../../images/icons/ico-trash.svg';
import iconTrashYellow from '../../images/icons/ico-trash-yellow.svg';
import iconEdit from '../../images/icons/ico-edit.svg';
import getPOList from './queries/getPoList';
import deletePo from './queries/deletePO';
import showAlert from '../../utils/alert';
import Loader from '../common/Loading';
import PoTable from './PoTable';
import useDebounce from '../../utils/debounce';
import externalLink from '../../images/icons/externalLink.svg';
import { FaInfoCircle } from "react-icons/fa";
import ConfirmShortClose from '../Modal/ConfirmShortClose';
import getVendorPoList from './queries/getVendorPoList';
import { matchesPoExpenseCategoryFilter } from './utils';
import RequestShortClose from '../Modal/RequestShortClose';
import { getShortCloseApprovalQuery } from './queries/getShortCloseApproval';
import requestShortClose from './queries/requestShortClose';
import { FaEye } from 'react-icons/fa';

const PoTableComponent = ({ filterData, search, policies, isVendor, isAssignedToMe, isShortCloseCompleted, isCrewPage, poListType = 'crew' }) => {
  const isAgencyPage = poListType === 'agency';
  const pocategoryValue = isAgencyPage ? 2 : (isCrewPage ? 0 : 1);
  const history = useHistory();
  const pageNoState = useSelector((state) => state.page.pageNo);
  const pageNoSize = useSelector((state) => state.page.pageSize);
  const [tableData, settableData] = useState([]);
  const [deleteModal, setdeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [vendorId, setVendorId] = useState('');
  const [isLoading, setisLoading] = useState(false);
  const [pageNo, setPageNo] = useState(pageNoState);
  const [shortCloseReason, setShortCloseReason] = useState('');
  const [approvalConfig, setApprovalConfig] = useState(null);

  const { crewID, vessel, vendor, poStatus, poInitiator,
    invoiceStatus, vesselOwner, budgetCategory,
    todate, fromdate, shortCloseStatus, plannedVesselRevisionId,
    serviceFromDate, serviceToDate, expenseCategoryId, expenseCategoryName } = filterData;
  const filData = {
    crewCode: crewID,
    plannedVesselId: vessel,
    plannedVesselRevisionId: plannedVesselRevisionId,
    vendorId: vendor,
    poStatus,
    poInitiator,
    invoiceStatus,
    vesselOwner,
    budgetCategory,
    expenseCategoryId,
    todate,
    fromdate,
    shortCloseStatus,
    ...(isAgencyPage && {
      serviceCompletionFromDate: serviceFromDate || undefined,
      serviceCompletionToDate: serviceToDate || undefined
    })
  };
  const debouncedSearch = useDebounce(search, 1000);
  useEffect(() => {
    // if debounce search .length > 3 set page to 1
    // else set page to current page
    if (debouncedSearch?.length > 3) {
      setPageNo(1);
    }
  }, [debouncedSearch]);
  const SeafearerDetails = (data) => {
    // open link in new tab
    window.open(process.env.REACT_APP_SEAFARER_URL + 'seafarer/details/' + data, '_blank');
  };
useEffect(() => {
  setPageNo(pageNoState);
}, [pageNoState]);
  const { isLoading: isPOListLoading, error, isFetching: isPOListFetching,
    data: POList, isError } = isVendor ? getVendorPoList({
      ...filData,
      page: pageNo,
      pageSize: pageNoSize,
      pocategory: pocategoryValue,
      assignedToMeSelected: isAssignedToMe,
      isShortCloseCompleted: isShortCloseCompleted,
      vendorId: null,
      search: debouncedSearch?.length > 3 ? debouncedSearch : null
    }) : getPOList({
      ...filData,
      page: pageNo,
      pocategory: pocategoryValue,
      pageSize: pageNoSize,
      search: debouncedSearch?.length > 3 ? debouncedSearch : null
    });
const { hasNext, hasPrev, totalItems, totalPages, currentPage } = POList?.data || {};
  const { mutate: deletePurchaseOrder, isLoading: isdeleteLoading, isSuccess: isdeleteSuccess,
    isError: isdeleteError, reset: resetdelete } = deletePo();
  const { mutate: initiateShortClose, isLoading: isshortCloseLoading } = requestShortClose();

  useEffect(() => {
    if (isPOListLoading || isPOListFetching || isdeleteLoading || isshortCloseLoading) {
      setisLoading(true);
    } else {
      setisLoading(false);
    }
  }, [isPOListLoading, isPOListFetching, isdeleteLoading, isshortCloseLoading]);

  const formatPOList = (poList) => {
    const formated = poList.map((item) => {
      if (item?.purchaseOrderCrew?.length > 0) {
        const purchaseOrderCrewItem = item?.purchaseOrderCrew.reduce((acc, cur) => {
          acc.amount += cur.amount;
          return acc;
        }, { amount: 0, SFname: '', CrewCode: '' });
        item.amount = purchaseOrderCrewItem.amount;
        item.SFname = purchaseOrderCrewItem.SFname;
        item.CrewCode = purchaseOrderCrewItem.CrewCode;
      }
      return item;
    });
    return formated;
  };

  useEffect(() => {
    const items = POList?.data?.items;
    if (!items?.length) {
      settableData([]);
      return;
    }
    const filteredItems = (expenseCategoryId || expenseCategoryName)
      ? items.filter((po) => matchesPoExpenseCategoryFilter(
        po,
        expenseCategoryId,
        expenseCategoryName
      ))
      : items;
    settableData(formatPOList(filteredItems));
  }, [POList, expenseCategoryId, expenseCategoryName]);

  if (isdeleteSuccess) {
    resetdelete();
    showAlert('Purchase Order Short Closed Successfully', 'success');
    setdeleteModal(false);
  }

  if (isdeleteError) {
    resetdelete();
    showAlert('Something went wrong', 'error');
  }

  const handleShortClose = (formValues) => {
    if (!deleteId) return;

    initiateShortClose(
      { formValues, poId: deleteId },
      {
        onSuccess: () => {
          setdeleteModal(false);
          showAlert('Purchase Order Short Close Request Initiated.', 'success');
        }
      }
    );
  };

  const handleDelete = () => {
    deletePurchaseOrder({ id: deleteId, reason: shortCloseReason });
    setShortCloseReason('');
  };
  const openDeleteModal = async (id, vendorCode) => {
    setisLoading(true);
    try {
      const config = await getShortCloseApprovalQuery(vendorCode, id);
      if (config?.status === false) {
        showAlert(config.message, 'warning');
      } else {
        setApprovalConfig(config);
        setDeleteId(id);
        setVendorId(vendorCode);
        setdeleteModal(true);
      }
    } catch (error) {
      showAlert('Oops! Something went wrong.', 'error');
    } finally {
      setisLoading(false);
    }
  };
  const handleEdit = (id) => {
    if (id)       {
        if (isAgencyPage) {
          history.push(`/edit-agency-po/${id}`);
        } else {
        history.push(`/edit-po/${id}`);
        }
      }
  };

  const columnHeaders = useMemo(
    () => [
      {
        Header: 'PO Date',
        accessor: 'createdAt',
        Cell: (props) => {
          const { createdAt, dueDate, poStatus } = props?.row?.original || {};
          return (
            <>
              {moment(createdAt).format('DD-MM-YYYY')}
              {poStatus === 'Submitted' || poStatus === 'Amended' || poStatus === 'Partially Closed' ? (
              <div className="py-2 items-center">
                <Chip style={{ backgroundColor: dueDate >= 180 ? '#f68681' : '#f8e3b4' }} size="small" label={dueDate} />
              </div>
              ) : null}
            </>
          );
        }
      },
      {
        Header: 'PO Number',
        accessor: 'poNumber',
        Cell: (props) => {
          const { poNumber, id, dueDate } = props?.row?.original || {};

          return (
            <>
              <div className="py-2 font-bold hover-link" style={{ color: dueDate >= 180 ? '#f68681' : '#333869' }}>
                <Link title={poNumber} to={`/po/${id}/${isVendor}`}>
                  {poNumber}
                </Link>
              </div>
            </>
          );
        }
      },
      {
        Header: 'PO Status',
        accessor: 'poStatus',
        Cell: (props) => {
          const { poStatus, dueDate } = props?.row?.original || {};

          return (
            <>
              <div className="py-2">
                <Chip style={{ backgroundColor: dueDate >= 180 ? '#f68681' : '#f8e3b4', borderRadius: 0 }} size="small" label={poStatus} />
              </div>
            </>
          );
        }
      },
      // ...(isAgencyPage
      //   ? [
      //       {
      //         Header: 'Service Completion Date',
      //         accessor: 'serviceCompletionDate',
      //         disableSortBy: true,
      //         Cell: (props) => {
      //           const { serviceCompletionDate } = props?.row?.original || {};
      //           return (
      //             <div className="py-2">
      //               {serviceCompletionDate ? moment(serviceCompletionDate).format('DD-MM-YYYY') : '-'}
      //             </div>
      //           );
      //         }
      //       }
      //     ]
      //   : []),
      {
        Header: 'Crew Name',
        accessor: 'SFname',
        disableSortBy: true,
        width: 900,
        Cell: (props) => {
          const { purchaseOrderCrew } = props?.row?.original || {};
          return (
            <ul>
            {purchaseOrderCrew?.map(({ firstName, lastName }, index) => {
              const fullName = [firstName, lastName].filter(Boolean).join(" ") || "N/A";   
              return (
                <li
                  key={index}
                  title={fullName}
                  className="my-2 truncate"
                >
                  {fullName}
                </li>
              );
            })}
          </ul>
          );
        }
      },
      {
        Header: 'Crew Code',
        accessor: 'CrewCode',
        disableSortBy: true,
        Cell: (props) => {
          const { purchaseOrderCrew } = props?.row?.original || {};
          const [tooltipStates, setTooltipStates] = useState({});
          
          const handleMouseEnter = (id) => {
            setTooltipStates(prev => ({ ...prev, [id]: true }));
          };
          
          const handleMouseLeave = (id) => {
            setTooltipStates(prev => ({ ...prev, [id]: false }));
          };
          return (
            <ul>
              {purchaseOrderCrew?.map(({ crewCode, shortCloseInitiatedDetails, id, crewId }) => (
                <li key={crewCode} className='flex items-center my-2'>
                  <div 
                    className="cursor-pointer hover-link flex items-center" 
                    title={crewCode}
                    onClick={() => SeafearerDetails(crewId)}
                  >
                    <span className="crew-code-number">{crewCode}</span>
                    <img src={externalLink} alt="externalLink" className="ml-1" />
                  </div>
                  {shortCloseInitiatedDetails?.isShortCloseInitiated && (
                    <Manager>
                      <Reference>
                        {({ ref }) => (
                          <div ref={ref}
                          className="hover-trigger ml-1 cursor-pointer"
                          onMouseEnter={() => handleMouseEnter(id)}
                          onMouseLeave={() => handleMouseLeave(id)} >
                             <FaInfoCircle/> 
                          </div>
                        )}
                      </Reference>
                      {tooltipStates[id] && (
                        <Popper
                          placement="bottom"
                          modifiers={{
                            flip: {
                              enabled: true,
                              behavior: ['bottom', 'top', 'right', 'left'],
                              boundariesElement: 'viewport'
                            },
                            preventOverflow: {
                              enabled: true,
                              boundariesElement: 'viewport'
                            }
                          }}
                        >
                          {({ ref, style, placement, arrowProps }) => (
                            <div
                              ref={ref}
                              style={style}
                              className="short-close-tooltip"
                              data-placement={placement}
                              onMouseEnter={() => handleMouseEnter(id)}
                              onMouseLeave={() => handleMouseLeave(id)}
                            >
                              <div className="tooltip-content">
                                <div className="font-bold">Short Close Status</div>
                                <div className="level-status">
                                  {shortCloseInitiatedDetails?.level1Status && (
                                    <div>Level 1 - {shortCloseInitiatedDetails.level1Status}</div>
                                  )}
                                  {shortCloseInitiatedDetails?.level2Status && (
                                    <div>Level 2 - {shortCloseInitiatedDetails.level2Status}</div>
                                  )}
                                </div>
                              </div>
                              <div ref={arrowProps.ref} style={arrowProps.style} className="popper-arrow" />
                            </div>
                          )}
                        </Popper>
                      )}
                    </Manager>
                  )}
                </li>
              ))}
            </ul>
          );
        }
      },
      {
        Header: 'Vessel Name',
        accessor: 'plannedVesselName',
        disableSortBy: true,
        Cell: (props) => {
          const { purchaseOrderCrew } = props?.row?.original || {};
          const [tooltipStates, setTooltipStates] = useState({});
          
          const handleMouseEnter = (id) => {
            setTooltipStates(prev => ({ ...prev, [id]: true }));
          };
          
          const handleMouseLeave = (id) => {
            setTooltipStates(prev => ({ ...prev, [id]: false }));
          };
          return (
            <ul>
            {purchaseOrderCrew?.map(({ plannedVesselName, id, encryptedCdcNumber, shortCloseInitiatedDetails }) => (
            <li className="truncate" title={plannedVesselName}>
            <li key={plannedVesselName} className='flex items-center my-1'>
              <div 
                className="flex items-center" 
                title={plannedVesselName}
              >
             <span className={
             isCrewPage
             ? "crew-code-number"
             : shortCloseInitiatedDetails?.isShortCloseInitiated
             ? "vessel-code-number"
             : "crew-code-number"
              }>
             {plannedVesselName}
             </span>
              </div>
              {!isCrewPage && shortCloseInitiatedDetails?.isShortCloseInitiated && (
                <Manager>
                  <Reference>
                    {({ ref }) => (
                      <div ref={ref}
                      className="hover-trigger ml-1 cursor-pointer"
                      onMouseEnter={() => handleMouseEnter(id)}
                      onMouseLeave={() => handleMouseLeave(id)} >
                         <FaInfoCircle/> 
                      </div>
                    )}
                  </Reference>
                  {tooltipStates[id] && (
                    <Popper
                      placement="bottom"
                      modifiers={{
                        flip: {
                          enabled: true,
                          behavior: ['bottom', 'top', 'right', 'left'],
                          boundariesElement: 'viewport'
                        },
                        preventOverflow: {
                          enabled: true,
                          boundariesElement: 'viewport'
                        }
                      }}
                    >
                      {({ ref, style, placement, arrowProps }) => (
                        <div
                          ref={ref}
                          style={style}
                          className="short-close-tooltip"
                          data-placement={placement}
                          onMouseEnter={() => handleMouseEnter(id)}
                          onMouseLeave={() => handleMouseLeave(id)}
                        >
                          <div className="tooltip-content">
                            <div className="font-bold">Short Close Status</div>
                            <div className="level-status">
                              {shortCloseInitiatedDetails?.level1Status && (
                                <div>Level 1 - {shortCloseInitiatedDetails.level1Status}</div>
                              )}
                              {shortCloseInitiatedDetails?.level2Status && (
                                <div>Level 2 - {shortCloseInitiatedDetails.level2Status}</div>
                              )}
                            </div>
                          </div>
                          <div ref={arrowProps.ref} style={arrowProps.style} className="popper-arrow" />
                        </div>
                      )}
                    </Popper>
                  )}
                </Manager>
              )}
            </li>
          </li>
            ))}
            </ul>
          );
        }
      },
      {
        Header: 'Expense Category',
        accessor: 'expenseCategoryName'
      },
      {
        Header: 'vendor',
        accessor: 'vendorsName',
        Cell: (props) => {
          const { vendorsName } = props?.row?.original || {};
          return (
            <div title={vendorsName} className="truncate">
              {vendorsName}
            </div>
          );
        }
      },
      {
        Header: 'PO Initiator',
        accessor: 'poInitiator',
        Cell: (props) => {
          const { poInitiator } = props?.row?.original || {};
          return (
            <div title={poInitiator} className="truncate">
              {poInitiator}
            </div>
          );
        }
      },
      {
        Header: 'Currency',
        accessor: 'currency',
        disableSortBy: true,
        Cell: (props) => {
          const { currency } = props?.row?.original || {};
          return (
            <div title={currency} className="align-middle">
              {currencyToSymbolMap(currency) || currency}
            </div>
          );
        }
      },
      {
        Header: 'Amount',
        accessor: 'crewTotalAmount',
        Cell: (props) => {
          const { crewTotalAmount } = props?.row?.original || {};
          return (
            <div title={Intl.NumberFormat('en-IN').format(crewTotalAmount)}>
              {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(crewTotalAmount)}
            </div>
          );
        }
      },
        ...(isAgencyPage
        ? [
            {
              Header: 'Advance Request',
              accessor: 'isAdvancePO',
              disableSortBy: true,
              Cell: (props) => {
                const { isAdvancePO } = props?.row?.original || {};
                const value = isAdvancePO === true || isAdvancePO === 'true';
                return (
                  <div title={value ? 'Yes' : 'No'} className="align-middle">
                    {value ? 'Yes' : 'No'}
                  </div>
                );
              }
            }
          ]
        : []),

      {
        Header: 'actions',
        accessor: 'actions',
        disableSortBy: true,
        Cell: (props) => {
          const { row: { original } } = props;
          const {
            id, isActive, poStatus, purchaseOrderCrew, isSyncFailure, vendorId,
            isAllShortCloseInitiated, isAgencyPoEditable,
            isAgencyPoShortclosePossibe
          } = props?.row?.original || {};
          const isEditHidden = isSyncFailure
            || !policies?.poPolicies?.canEdit
            || (isAgencyPage === true && !policies?.agencyPoPolicies?.canEdit);
          // Edit: disable on Agency PO when isAgencyPoEditable is false; enable when true.
          const isEditDisabled = isAgencyPage === true && isAgencyPoEditable === false;
          const isEditEnabled = !isEditDisabled;
          // Short-close: disable on Agency PO when isAgencyPoEditable or isAgencyPoShortclosePossibe is false.
          const isShortCloseDisabled = isAgencyPage === true && (
            isAgencyPoEditable === false || isAgencyPoShortclosePossibe === false
          );
          return (
            <>
              {isActive && isVendor === false ? (
                <div className="po-table-action ">
                  <button
                    type="button"
                    onClick={() => isEditEnabled && handleEdit(id)}
                    hidden={isEditHidden}
                    disabled={isEditDisabled}
                    title={isEditDisabled ? 'Edit is not available for this PO' : 'edit'}
                  >
                    <img className={`action-icon w-6 ${isEditDisabled ? 'opacity-50 cursor-not-allowed' : ''}`} src={iconEdit} alt="edit-icon" />
                  </button>
                  <button
                    type="button"
                    hidden={poStatus?.toLowerCase().includes('partially')
                    || !policies?.poPolicies.canEdit
                    || (isAgencyPage === true && !policies?.agencyPoPolicies?.canEdit)
                  //  or purchaseOrderCrew having invoice status not null and value pending
                    || purchaseOrderCrew?.some(({ invoiceStatus }) => invoiceStatus?.toLowerCase() !== 'pending' && invoiceStatus !== null)
                    || purchaseOrderCrew?.some(({ serviceStatus }) => serviceStatus)}
                    disabled={isShortCloseDisabled}
                    title={isShortCloseDisabled ? 'Short close is not available for this PO' : 'short-close'}
                    onClick={() => !isShortCloseDisabled && openDeleteModal(id, vendorId)}
                  >
                     <img
                      className={`action-icon w-6 ${isShortCloseDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                      src={isAllShortCloseInitiated ? iconTrashYellow : iconTrash}
                      alt="short-close"
                    />
                  </button>
                </div>
              ) : ''}
              {isVendor && (
                <Link to={`/po/${id}/${isVendor}`} className="flex items-center justify-center">
                  <FaEye title="View Details" />
                </Link>
              )}
            </>
          );
        }
      }
    ],
  [isAgencyPage, policies, isVendor, isCrewPage, poListType]);
  return (
    <>
{
  isdeleteLoading ? (
    <Loader />
  ) : (
    <>
      <PoTable
        {...{
          hasNext,
          isCrewPage, 
          isAgencyPage,
          hasPrev,
          totalItems,
          totalPages,
          currentPage,
          columnHeaders,
          tableData,
          isLoading,
          error,
          isError
        }}
      />
              {deleteModal && approvalConfig?.shortCloseApprovalRequired ? (
                <RequestShortClose
                  modal={deleteModal}
                  isLoading={isLoading}
                  setModal={setdeleteModal}
                  handleDelete={handleShortClose}
                  approvalConfig={approvalConfig}
                  vendorId={vendorId}
                  purchaseOrderId={deleteId}
                />
              ) : deleteModal && (
                <ConfirmShortClose
                  modal={deleteModal}
                  setModal={setdeleteModal}
                  handleDelete={handleDelete}
                  shortCloseReason={shortCloseReason}
                  setShortCloseReason={setShortCloseReason}
                  message=" Short Close"
                />
              )}
    </>
  )
}

    </>
  );
};

export default PoTableComponent;
